import React from "react";

import '../styles/update.css';

export default function({ date, title, link, children }) {
	return <div className='update'>
        <h1>{date}</h1>
        <a style={{ textDecoration: 'underline' }} href={link}>{title}</a>
        <p>{children}</p>
	</div>
}